import { useCallback, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Welcome from "@/components/Welcome";
import PersonalInfo from "@/components/PersonalInfo";
import Assessment from "@/components/Assessment";
import Results from "@/components/Results";
import { BrandHeader } from "@/components/Brand";
import { buildRoadmap } from "@/lib/scoring";
import { captureMeta } from "@/lib/lunar";

// All participant data lives only in this component's memory and is discarded on reset or page close.
const EMPTY_PROFILE = {
  firstName: "", lastName: "", email: "", dob: "", birthTime: "",
  birthCity: "", birthState: "", birthCountry: "", sunSign: "", moonSign: "", humanDesign: "",
};

export default function App() {
  const [stage, setStage] = useState("welcome");
  const [profile, setProfile] = useState(EMPTY_PROFILE);
  const [meta, setMeta] = useState(null);
  const [roadmap, setRoadmap] = useState(null);

  const reset = useCallback(() => {
    setProfile(EMPTY_PROFILE);
    setMeta(null);
    setRoadmap(null);
    setStage("welcome");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const startAssessment = () => {
    setMeta(captureMeta(new Date()));
    setStage("assessment");
    window.scrollTo({ top: 0 });
  };

  const complete = (answers) => {
    setMeta(captureMeta(new Date()));
    setRoadmap(buildRoadmap(answers, profile.firstName.trim()));
    setStage("results");
    window.scrollTo({ top: 0 });
  };

  return (
    <div className="App sacred-bg grain relative">
      <div className="relative z-10">
        <BrandHeader onHome={stage === "results" ? null : stage !== "welcome" ? reset : null} />
        {stage === "welcome" && <Welcome onBegin={() => { setStage("info"); window.scrollTo({ top: 0 }); }} />}
        {stage === "info" && <PersonalInfo profile={profile} setProfile={setProfile} onContinue={startAssessment} onBack={() => setStage("welcome")} />}
        {stage === "assessment" && <Assessment onComplete={complete} onExit={() => setStage("info")} />}
        {stage === "results" && roadmap && <Results profile={profile} meta={meta} roadmap={roadmap} onRetake={reset} />}
      </div>
      <Toaster position="top-center" richColors />
    </div>
  );
}
